// extracted by mini-css-extract-plugin
export default {"links":"links__Mdlstg","orDivider":"orDivider__d1lxrK"};